export default __webpack_public_path__ + "static/media/pic4.cc86e1d5.jpg";